module.exports = __webpack_public_path__ + "static/ever-white-ecd097e50a1f09b8b950a329c2837f75.png";